/* eslint-disable security/detect-object-injection */
import React, { useContext, useEffect, useRef, useState } from 'react';
import CameraCapture from '../../components/CameraCapture';
import AnimatedPageFade from '../../components/Animations/AnimatedPageFade';
import IdentificationHeader from './IdentificationHeader';
import FileLoader from '../../components/FileLoader';
import { dataService } from '../../services/data.service';
import ApplicationContext from '../../context/ApplicationContext';
import BackButton from '../../components/Button/BackButton';
import NextButton from '../../components/Button/NextButton';
import { identificationLanguageContent } from './IdentificationLanguageContent';

function TakePhoto(props) {
    const { handlePage, setIdCardData, idCardData, sessionData, selectedLanguage } = useContext(ApplicationContext);
    const videoRef = useRef(null);
    const [idCardImage, setidCardImage] = useState('');
    const [imageLoading, setImageLoading] = useState(true);
    const [loading, setLoading] = useState(false);

    const getIdentityCardDetails = () => {
        dataService.getIDCardDetails(sessionStorage.getItem('session')).then((res) => {
            if(res.error === false) {
                setIdCardData(res.data.data);
                if(res.data.data.card_image) {
                    const file = res.data.data.card_image.split('/');
                    setidCardImage(file[1].includes('id-capture') ? res.data.data.card_image : '');
                    setImageLoading(false);
                } else {
                    setImageLoading(false);
                }
            } else {
                setImageLoading(false);
            }
        })
    }

    useEffect(() => {
        getIdentityCardDetails();
    }, []);

    const handleSubmitImage = () => {
        setLoading(true);
        const payload = {
            "card_image": idCardImage || '',
            'upload_type': 'capture',
            'process_ocr': false
        }
        if(idCardImage !== idCardData.card_image || !idCardData.card_issuer) {
            payload['process_ocr'] = true;
        }
        dataService.updateIDDetails(sessionStorage.getItem('session'), payload).then((res) => {
            if(res.error === false) {
                setLoading(false);
                if (videoRef.current && videoRef.current.srcObject) {
                    const tracks = videoRef.current.srcObject.getTracks();
                    tracks.forEach((track) => track.stop());
                }
                setidCardImage('');
                handlePage('card_details', '', '', sessionData['review'] === 'previous' ? 'previous' : '')
            }
        })
    }
    const handleBackFromUpload = () => {
        if (videoRef.current && videoRef.current.srcObject) {
            const tracks = videoRef.current.srcObject.getTracks();
            tracks.forEach((track) => track.stop());
        }
        setidCardImage('');
        handlePage('upload_id_choice', '', '', sessionData['review'] === 'previous' ? 'previous' : '');
    }

    return (
        <AnimatedPageFade className='flex flex-col justify-between relative h-welcome gradient-bg rounded-[16px] overflow-auto'>
            <IdentificationHeader />
            <div className='p-[8px] overflow-x-hidden overflow-y-auto options-height Form-scroll mt-[18px] '>
                <div className='mx-[12px] '>
                    <div>
                        {identificationLanguageContent['take-photo'][selectedLanguage]}
                        <div className='mt-[32px]'>
                            {imageLoading 
                                ? <FileLoader /> 
                                : <CameraCapture id="id" 
                                    cameraTitle={<p className='bg-[#F2F2F2] px-[5px] text-[11px]'>{identificationLanguageContent['identification'][selectedLanguage]}<b className='text-primary'> {identificationLanguageContent['front'][selectedLanguage]}</b></p>} 
                                    imageLoading={imageLoading} setImageLoading={setImageLoading} videoRef={videoRef} filePath="patients/id-capture" capturedImage={idCardImage} setCapturedImage={setidCardImage} />}
                        </div>
                    </div>
                </div>
            </div>
            <div className='flex mb-[24px] justify-between mx-[16px] w-auto fold-gap pt-[20px] gap-[12px] '>
                <BackButton disabled={loading || imageLoading} handleClick={() => handleBackFromUpload()} backType="previous" />
                <NextButton disabled={idCardImage === '' || loading} handleClick={() => handleSubmitImage()}  loader={loading} />
            </div>
        </AnimatedPageFade>
    );
}

export default TakePhoto;